import { render, staticRenderFns } from "./ReporteCompartivaAreasDocente.vue?vue&type=template&id=168fa54c&scoped=true"
import script from "./ReporteCompartivaAreasDocente.vue?vue&type=script&lang=js"
export * from "./ReporteCompartivaAreasDocente.vue?vue&type=script&lang=js"
import style0 from "./ReporteCompartivaAreasDocente.vue?vue&type=style&index=0&id=168fa54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fa54c",
  null
  
)

export default component.exports